export const FIRST = 'first';
export const SECOND = 'second';
export const THIRD = 'third';
export const LAST = 'last';